module.exports = __webpack_public_path__ + "static/substhumb-7f0426c9abab5906a0ae62138312ee04.jpg";